import * as THREE from 'three';

export class SceneManager {
    constructor(app) {
        this.app = app;
        this.scenes = new Map();
        this.currentScene = null;
        this.currentSceneName = null;
        
        this.setupLighting();
    }

    setupLighting() {
        // Ambient light for general illumination
        this.ambientLight = new THREE.AmbientLight(0xffffff, 0.4);
        
        // Main directional light with enhanced shadows
        this.directionalLight = new THREE.DirectionalLight(0xffffff, 1.2);
        this.directionalLight.position.set(-4, 8, -3); // Position directly above donut for straight down shadow
        this.directionalLight.target.position.set(-4, 0, -3); // Target the donut position
        this.directionalLight.castShadow = true;
        
        // Enhanced shadow settings for better quality
        this.directionalLight.shadow.mapSize.setScalar(2048); // Higher resolution
        this.directionalLight.shadow.camera.near = 0.1;
        this.directionalLight.shadow.camera.far = 25;
        this.directionalLight.shadow.camera.top = 10;
        this.directionalLight.shadow.camera.bottom = -10;
        this.directionalLight.shadow.camera.left = -10;
        this.directionalLight.shadow.camera.right = 10;
        this.directionalLight.shadow.bias = -0.0005; // Reduce shadow acne
        this.directionalLight.shadow.normalBias = 0.02;
        
        // Add a second light for rim lighting
        this.rimLight = new THREE.DirectionalLight(0x00ffff, 0.3);
        this.rimLight.position.set(2, 3, -2);
        // No shadows for rim light to avoid conflicts
    }

    addScene(name, scene) {
        this.scenes.set(name, scene);
    }

    setScene(name) {
        const scene = this.scenes.get(name);
        if (!scene) {
            console.warn(`Scene "${name}" not found`);
            return;
        }

        this.currentScene = scene;
        this.currentSceneName = name;
        
        this.currentScene.add(this.ambientLight);
        this.currentScene.add(this.directionalLight);
        this.currentScene.add(this.rimLight);
        
        console.log(`Switched to scene: ${name}`);
    }

    getScene(name) {
        return this.scenes.get(name);
    }

    getCurrentScene() {
        return this.currentScene;
    }

    getCurrentSceneName() {
        return this.currentSceneName;
    }

    updateLighting(config) {
        if (config.ambient) {
            this.ambientLight.intensity = config.ambient.intensity || this.ambientLight.intensity;
            this.ambientLight.color.setHex(config.ambient.color || this.ambientLight.color.getHex());
        }

        if (config.directional) {
            this.directionalLight.intensity = config.directional.intensity || this.directionalLight.intensity;
            this.directionalLight.color.setHex(config.directional.color || this.directionalLight.color.getHex());
            
            if (config.directional.position) {
                this.directionalLight.position.set(
                    config.directional.position.x || this.directionalLight.position.x,
                    config.directional.position.y || this.directionalLight.position.y,
                    config.directional.position.z || this.directionalLight.position.z
                );
            }
        }
    }

    dispose() {
        this.scenes.forEach((scene) => {
            scene.traverse((object) => {
                if (object.geometry) object.geometry.dispose();
                if (object.material) {
                    if (Array.isArray(object.material)) {
                        object.material.forEach(material => material.dispose());
                    } else {
                        object.material.dispose();
                    }
                }
            });
        });
        
        this.scenes.clear();
    }
}